module.exports = __webpack_public_path__ + "static/media/starProduct8.0868f945.png";